export const CMS_MODEL_ID = 'standalone-page';
